import React from 'react';

import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

import Calories from 'bento-ordering/menus/components/Calories';
import { getItemDetailString } from 'bento-ordering/menus/utils/getItemDetailString';
import { MENU_ITEM_PROPTYPES } from 'bento-ordering/base/constants/propTypes';
class MenuItemDescription extends React.Component {
  static propTypes = MENU_ITEM_PROPTYPES;

  renderDietaryText = () => {
    const { spicy, vegetarian, vegan, kosher, halal, organic } = this.props;

    return getItemDetailString([
      { Spicy: spicy },
      { Vegan: vegan },
      { Vegetarian: vegetarian },
      { Kosher: kosher },
      { Halal: halal },
      { Organic: organic }
    ]);
  };

  renderAllergensText = () => {
    const {
      dairy,
      peanut,
      tree_nut,
      dairy_free,
      peanut_free,
      tree_nut_free,
      egg,
      shellfish,
      wheat,
      egg_free,
      shellfish_free,
      gluten_free,
      fish,
      soy,
      fish_free,
      soy_free
    } = this.props;

    const allergens = [
      { Dairy: dairy },
      { Peanut: peanut },
      { 'Tree Nut': tree_nut },
      { 'Dairy Free': dairy_free },
      { 'Peanut Free': peanut_free },
      { 'Tree Nut Free': tree_nut_free },
      { Egg: egg },
      { Shellfish: shellfish },
      { Wheat: wheat },
      { 'Egg Free': egg_free },
      { 'Shell Fish Free': shellfish_free },
      { 'Gluten Free': gluten_free },
      { Fish: fish },
      { Soy: soy },
      { 'Fish Free': fish_free },
      { 'Soy Free': soy_free }
    ];

    return allergens
      .filter(allergen => allergen[Object.keys(allergen)[0]])
      .map(allergen => Object.keys(allergen)[0])
      .join(', ')
      .trim(', ');
  };

  render() {
    const { name, description, calories } = this.props;
    const allergens = this.renderAllergensText();
    const dietary = this.renderDietaryText();
    return (
      <Box borderBottom={1} color="borders.primary">
        <Box p={2.5}>
          <Typography variant="h4" component="h2">
            {name}
          </Typography>
          {description && (
            <Box pt={1} pb={1}>
              <Typography variant="body1">{description}</Typography>
            </Box>
          )}
          {allergens && (
            <Box data-testid="allergens">
              <Typography component="span" variant="body1">
                {allergens}
              </Typography>
            </Box>
          )}
          {dietary && (
            <Box data-testid="dietary-type" pt={1}>
              <Typography component="span" variant="body1">
                {dietary}
              </Typography>
            </Box>
          )}
          {calories && (
            <Box pt={1}>
              <Calories calories={calories} />
            </Box>
          )}
        </Box>
      </Box>
    );
  }
}

export default MenuItemDescription;
